import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from 'core/components/Button';

@observer
class SectionPanelTitleTools extends Component {
  handleCollapsePanel = () => {
    const { panel, onSectionLayoutChange } = this.props;
    panel.set('config', { ...panel.get('config'), collapsed: true });
    // find panel in layout and set h to 0
    onSectionLayoutChange({ panel, panelHeight: 0 });
  };

  handleExpandPanel = () => {
    const { panel, onSectionLayoutChange } = this.props;
    panel.set('config', { ...panel.get('config'), collapsed: false });

    // find panel in layout and set h to 0
    onSectionLayoutChange({ panel, panelHeight: panel.getBodyContentsHeight() });
  };

  render() {
    const { panel } = this.props;
    const collapsed = !!panel.get('config.collapsed');
    const icon = collapsed ? 'caret-right' : 'caret-down';
    const onClick = collapsed ? this.handleExpandPanel : this.handleCollapsePanel;

    if (panel.panels.length === 0) {
      return null;
    }

    return <Button icon={icon} onClick={onClick} minimal ml={-1} onMouseDown={(e) => e.stopPropagation()} />;
  }
}

export default SectionPanelTitleTools;
